import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RoundSelectComponent } from "../UI/round-select/round-select.component";
import { SearchService } from '../../services/Search/search.service';

@Component({
    selector: 'app-search-input',
    imports: [
        CommonModule,
        FormsModule,
        RoundSelectComponent
    ],
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.scss'
})
export class SearchInputComponent {
    // public searchText: string = ""
    @Input('color') color: string = "blue"
    @Output() changeEvent = new EventEmitter<string>();
    @Output() searchEvent = new EventEmitter<string>();

    constructor(
        public searchService: SearchService
    ) {
        this.searchService.forceSearch$.subscribe(text => {
            this.onSearch()
        })
    }

    onSearch(e?: Event) {
        // console.log(this.searchText)
        this.changeEvent.next(this.searchService.searchText)
    }

    onSearchButton(e?: Event) {
        this.searchEvent.next(this.searchService.searchText)
    }

    toggleGenreFilter() {
        if(this.searchService.isGenreFilterOpen) {
            this.searchService.closeGenreFilter()
        }
        else {
            this.searchService.openGenreFilter()

            this.searchService.closeFormatFilter()
            this.searchService.closeRatingFilter()
        }
    }
    toggleFormatFilter() {
        if(this.searchService.isFormatFilterOpen) {
            this.searchService.closeFormatFilter()
        }
        else {
            this.searchService.openFormatFilter()

            this.searchService.closeGenreFilter()
            this.searchService.closeRatingFilter()
        }
    }
    toggleRatingFilter() {
        if(this.searchService.isRatingFilterOpen) {
            this.searchService.closeRatingFilter()
        }
        else {
            this.searchService.openRatingFilter()

            this.searchService.closeGenreFilter()
            this.searchService.closeFormatFilter()
        }
    }
}
